import React from 'react';
import { connect } from 'react-redux';

import { userCheck } from 'containers/App/actions';

/**
 * Restrict access to children to authenticated users
 *
 * Useful for Route components ; used internally by Resource.
 * Use it to decorate your custom page components to require
 * authentication.
 *
 * Pass the `location` from the `routeParams` as `location` prop.
 * You can set additional `authParams` at will if your authProvider
 * requires it.
 */
export class Authenticated extends React.Component {
  componentDidMount() {
    this.checkAuthentication();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location !== this.props.location) {
      this.checkAuthentication();
    }
  }

  checkAuthentication() {
    const { userCheck, authParams, location } = this.props;
    userCheck(authParams, location && location.pathname);
  }

  // render the child even though the AUTH_CHECK isn't finished (optimistic rendering)
  render() {
    const { children, userCheck, authParams, ...rest } = this.props;
    return React.cloneElement(children, rest);
  }
}

export default connect(
  null,
  { userCheck },
)(Authenticated);
